import { InjectionToken } from '@angular/core';
import { resolveByCountry } from './country-resolver';

export const I18N_OPTIONS_TOKEN = new InjectionToken<I18nOptions>('I18N_OPTIONS_TOKEN');

/**
 * The product's default country code (for example 'US' or 'AU'), used to resolve the
 * effective locale when the country claim is absent.
 */
export const PRODUCT_DEFAULT_COUNTRY_CODE = new InjectionToken<string>('ProductDefaultCountryCode');

export interface I18nOptions {
    locale: 'en-US' | 'en-AU';
    phoneNumber: {
        stringMask: string;
        regularExpressionMask: RegExp;
        regularExpressionArrayMask: Array<RegExp | string>;
        digitsOnlyMask: RegExp;
    };
    currencyCode: string;
    dateFormat: string;
    dateTimeFormat: string;
    /**
     * User-facing label for sales tax on customer-facing surfaces (for example 'Taxes' in the US,
     * 'GST' in Australia).
     */
    taxLabel: string;
    /**
     * Whether sales tax is inclusive of the displayed line prices. When true (for example Australian
     * GST) the per-line tax is already contained in the subtotal, so it is shown as an included
     * component and NOT added to the grand total. When false the tax is added on top of the subtotal.
     */
    taxInclusive: boolean;
}

// TODO: making compatible with TM data for now, need to review later
export const US_I18N_OPTIONS: I18nOptions = {
    locale: 'en-US',
    phoneNumber: {
        stringMask: '999-999-9999',
        regularExpressionMask: /^\d{3}-\d{3}-\d{4}$/,
        regularExpressionArrayMask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        digitsOnlyMask: /^\d{10}$/,
    },
    currencyCode: 'USD',
    dateFormat: 'MM/dd/yyyy',
    dateTimeFormat: 'MM/dd/yyyy hh:mm:ss a',
    taxLabel: 'Tax',
    taxInclusive: false,
};

export const AU_I18N_OPTIONS: I18nOptions = {
    locale: 'en-AU',
    phoneNumber: {
        stringMask: '9999999999',
        regularExpressionMask: /^\d{10}$/,
        regularExpressionArrayMask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
        digitsOnlyMask: /^\d{10}$/,
    },
    currencyCode: 'AUD',
    dateFormat: 'dd/MM/yyyy',
    dateTimeFormat: 'dd/MM/yyyy hh:mm:ss a',
    taxLabel: 'GST',
    taxInclusive: true,
};

/** Resolves the i18n options for the given country code. */
export function i18nOptionsFor(country: string | undefined | null, productDefault: I18nOptions): I18nOptions {
    return resolveByCountry(country, US_I18N_OPTIONS, AU_I18N_OPTIONS, productDefault);
}
